/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { CssContato } from "./css";
import Swal from "sweetalert2";
import { visible } from "@/services/functions";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";

import PontaSuperiorBranca from "@/assets/Images/pontaSuperiorBranca.png";
import SetaBranca from "@/assets/Images/setaBranca.png";
import ZVermelho from "@/assets/Images/z-vermelho.png";
import TarjaVermelha from "@/assets/Images/tarjaVermelha.png";
import Equipe from "@/assets/Images/equipe.jpg";

import Michelle from "@/assets/Images/michelle.jpg";
import Vitor from "@/assets/Images/vitor.jpg";
import Carol from "@/assets/Images/carol.jpg";
import Samuel from "@/assets/Images/samuel.jpg";

const Contato = () => {
  const { t } = useTranslation();

  const [nome, SetNome] = useState("");
  const [email, SetEmail] = useState("");
  const [mensagem, SetMensagem] = useState("");
  const [block, SetBlock] = useState("");

  const [typedVamosFalar, setTypedVamosFalar] = useState("");

  const sectionRef = useRef(null);
  const [isContatoVisible, setIsContatoVisible] = useState(false);
  const [arrowRotation, setArrowRotation] = useState(0);

  const [activeLeaderIndex, setActiveLeaderIndex] = useState(null);

  const teamTitle = t("contato.nossaLideranca");

  const leaders = useMemo(
    () => [
      {
        name: "Michelle de Paula",
        role: "CEO & Founder",
        photo: Michelle,
      },
      {
        name: "Vitor Pagani",
        role: "Partner & Head of Events and Production",
        photo: Vitor,
      },
      {
        name: "Carol Siqueira",
        role: "Head of Content and Communications",
        photo: Carol,
      },
      {
        name: "Samuel Segatelli",
        role: "Associate Executive Creative Director",
        photo: Samuel,
      },
    ],
    []
  );

  const vamosFalarText = t("contato.vamosFalar");

  const currentLeader =
    activeLeaderIndex !== null ? leaders[activeLeaderIndex] : null;

  const currentPhoto = currentLeader ? currentLeader.photo : Equipe;
  const currentPhotoAlt = currentLeader ? currentLeader.name : "Nosso time";

  useEffect(() => {
    if (nome === "" || email === "" || mensagem === "") {
      SetBlock("disabled");
    } else {
      SetBlock("");
    }
  }, [nome, email, mensagem]);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsContatoVisible(entry.isIntersecting);
      },
      {
        threshold: 0.28,
      }
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;

      setArrowRotation((prev) => prev + delta * 0.6);
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!isContatoVisible) {
      setTypedVamosFalar("");
      setActiveLeaderIndex(null);
      return;
    }

    setTypedVamosFalar("");

    let j = 0;
    let timeout;

    const typeVamosFalar = () => {
      if (j <= vamosFalarText.length) {
        setTypedVamosFalar(vamosFalarText.slice(0, j));
        j += 1;
        timeout = setTimeout(typeVamosFalar, 45);
      }
    };

    typeVamosFalar();

    return () => {
      clearTimeout(timeout);
    };
  }, [isContatoVisible, vamosFalarText]);

  useEffect(() => {
    if (!isContatoVisible || !leaders.length) return;

    const timer = setTimeout(() => {
      setActiveLeaderIndex((prev) => {
        if (prev === null) return 0;
        return (prev + 1) % leaders.length;
      });
    }, 4000);

    return () => clearTimeout(timer);
  }, [isContatoVisible, activeLeaderIndex, leaders]);

  const handleLeaderClick = (index) => {
    setActiveLeaderIndex(index);
  };

  const EnviaContato = async (load1, load2) => {
    visible(load1);
    visible(load2);

    const dados = {
      from_name: nome,
      email: email,
      mensagem: mensagem,
    };

    try {
      const response = await emailjs.send(
        "service_6de49fn",
        "template_46ux60e",
        dados,
        "lDF5NaTvP9NcnN9TD"
      );

      if (response.status === 200) {
        visible(load1);
        visible(load2);

        Swal.fire({
          icon: "success",
          title: t("contato.enviado"),
          html: t("contato.sucessoEnvio"),
        });

        SetNome("");
        SetEmail("");
        SetMensagem("");
      } else {
        visible(load1);
        visible(load2);

        Swal.fire({
          icon: "warning",
          title: t("contato.atencao"),
          html: t("contato.erroEnvio"),
        });
      }
    } catch (error) {
      visible(load1);
      visible(load2);

      Swal.fire({
        icon: "warning",
        title: t("contato.atencao"),
        html: t("contato.erroEnvio"),
      });
    }
  };

  return (
    <CssContato>
      <section
        id="faleConosco"
        ref={sectionRef}
        className={isContatoVisible ? "is-visible" : ""}
      >
        <div className="contactTop">
          <div
            className={`decor decor--topLeft ${isContatoVisible ? "is-active" : ""}`}
          >
            <img
              src={PontaSuperiorBranca}
              alt=""
              aria-hidden="true"
              className="decor__piece decor__piece--white"
            />
          </div>

          <img
            src={SetaBranca}
            alt=""
            aria-hidden="true"
            className="setaScroll"
            style={{
              transform: `rotate(${arrowRotation}deg)`,
            }}
          />

          <div className="container">
            <div className="teamGrid">
              <div className={`teamTitle ${isContatoVisible ? "is-active" : ""}`}>
                {teamTitle.split("\n").map((line, idx) => (
                  <span key={idx}>{line}</span>
                ))}
              </div>

              <div className={`teamPhotoWrap ${isContatoVisible ? "is-active" : ""}`}>
                <img src={currentPhoto} alt={currentPhotoAlt} className="teamPhoto" />
              </div>

              <div className="teamTextWrap">
                <div className="teamText">
                  {leaders.map((leader, idx) => {
                    const isActive = idx === activeLeaderIndex;

                    return (
                      <React.Fragment key={leader.name}>
                        <button
                          type="button"
                          className="teamLeaderButton"
                          onClick={() => handleLeaderClick(idx)}
                          style={{
                            display: "block",
                            background: "transparent",
                            border: "none",
                            padding: 0,
                            margin: 0,
                            textAlign: "left",
                            cursor: "pointer",
                            fontFamily: "inherit",
                            color: isActive ? "#ff1a00" : "#173644",
                            transition: "color 0.3s ease",
                          }}
                        >
                          <div
                            className="teamText__name"
                            style={{
                              color: isActive ? "#ff1a00" : "#173644",
                              transition: "color 0.3s ease",
                            }}
                          >
                            {leader.name}
                          </div>
                        </button>

                        <div
                          className="teamText__role"
                          style={{
                            color: isActive ? "#ff1a00" : "#173644",
                            transition: "color 0.3s ease",
                          }}
                        >
                          {leader.role}
                        </div>

                        {idx !== leaders.length - 1 && (
                          <div className="teamText__space" />
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contactBottom">
          <div className={`bottomZWrap ${isContatoVisible ? "is-active" : ""}`}>
            <img
              src={ZVermelho}
              alt=""
              aria-hidden="true"
              className="bottomZ"
            />
          </div>

          <div className={`tarjaWrap ${isContatoVisible ? "is-active" : ""}`}>
            <img
              src={TarjaVermelha}
              alt=""
              aria-hidden="true"
              className="tarjaVermelha"
            />
          </div>

          <div className="container">
            <h6 className="vamosFalarTitle">
              {typedVamosFalar}
              {typedVamosFalar !== vamosFalarText && (
                <span className="typingCaret">|</span>
              )}
            </h6>

            <div id="formulario">
              <form>
                <input
                  type="text"
                  value={nome}
                  onChange={(e) => SetNome(e.target.value)}
                  placeholder={t("contato.nome")}
                  className="input-branco"
                />

                <input
                  type="text"
                  value={email}
                  onChange={(e) => SetEmail(e.target.value)}
                  placeholder={t("contato.email")}
                  className="input-branco"
                />

                <textarea
                  rows="5"
                  placeholder={t("contato.mensagem")}
                  value={mensagem}
                  onChange={(e) => SetMensagem(e.target.value)}
                  className="input-branco"
                ></textarea>

                <button
                  type="button"
                  onClick={() => EnviaContato("Enviar", "Aguarde")}
                  disabled={block}
                  id="Enviar"
                >
                  {t("contato.enviar")}
                </button>

                <button
                  type="button"
                  disabled={"disabled"}
                  id="Aguarde"
                  style={{ display: "none" }}
                >
                  <i className="pi pi-spin pi-spinner"></i> {t("contato.aguarde")}
                </button>
              </form>
            </div>
           
          </div>
        </div>
      </section>
    </CssContato>
  );
};

export default Contato;